import { render } from "./UiAvatar.vue?vue&type=template&id=3523adc6&scoped=true"
import script from "./UiAvatar.vue?vue&type=script&lang=js"
export * from "./UiAvatar.vue?vue&type=script&lang=js"

import "./UiAvatar.vue?vue&type=style&index=0&id=3523adc6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3523adc6"]])

export default __exports__